import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { alpha, Card, Grid, Stack, Theme } from '@mui/material';
import Icon from '@/components/icon';
import Text from '@/components/text';

const useStyles = createUseStyles((theme: Theme) => ({
  emptyTile: {
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    border: `1px solid ${theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[300]}`,
    borderRadius: theme.shape.borderRadius,
    padding: '8px',
    pointerEvents: 'none',
    position: 'relative',
    backgroundColor: alpha(
      theme.palette.mode === 'dark' ? theme.palette.background.linkbar : theme.palette.common.white,
      0.5
    ),
    '& .title': {
      textAlign: 'center',
    },
  },
}));

const EmptyTile: FC = () => {
  const styles = useStyles();

  return (
    <Grid item xs={6} xxs={12} sm={4} md={4} lg={3} height={150}>
      <Card elevation={0} className={styles.emptyTile}>
        <Stack justifyContent="center" alignItems="center" width="100%" height="100%" gap={1}>
          <Icon name="problem" size="large" />
          <Text size="small" className="title">
            No matches found
          </Text>
        </Stack>
      </Card>
    </Grid>
  );
};

export default EmptyTile;
